import { render, staticRenderFns } from "./spell.vue?vue&type=template&id=5312cc56&"
import script from "./spell.vue?vue&type=script&lang=js&"
export * from "./spell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports